import { z } from 'zod'

export const CompanyCreateSchema = z.object({
  name: z.string().min(1, { message: 'Please enter a name' }),
  type: z.enum(['SITE', 'RADIOLOGY_CENTER', 'SPONSOR', 'INTERNAL', 'INDEPENDENT_READER'], {
    errorMap: (issue, ctx) => {
      if (issue.code === 'invalid_enum_value' || issue.code === 'invalid_type') {
        return { message: 'Please select company type' }
      }
      return { message: ctx.defaultError }
    },
  }),
  contact_person_name: z.union([z.string().min(1), z.literal(''), z.null()]).optional(),
  email: z.union([z.string().email({ message: 'Please enter a valid email' }), z.literal(''), z.null()]).optional(),
  phone: z
    .union([z.string().regex(/^\d+$/, { message: 'Please enter only numbers' }).min(1), z.literal(''), z.null()])
    .optional(),
})
